<template>
	<div v-if="type === 'form-not-available' || type === 'invalid-share-link'" class="cog-wrapper cog-body">
		<c-content v-if="notAvailableMessage" class="cog-confirmation__message" :content="notAvailableMessage" />
	</div>
	<div v-else class="cog-invalid-form cog-cognito cog-form">
		<div class="cog-form__container">
			<template v-if="type === 'suspicious-content'">
				<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700&amp;text=InvalidForm!">
				<h1>Invalid Form!</h1>
				<p>Our apologies, this form has been disabled due to suspicious content.</p>
			</template>
			<template v-else-if="type === 'form-not-found'">
				<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700&amp;text=Formnotfound!">
				<h1>Form not found!</h1>
				<p>Sorry, the form you are looking for no longer exists.</p>
			</template>
		</div>
	</div>
</template>

<script>
	import CContent from './Content.vue';

	export default {
		name: 'CInvalidForm',
		components: {
			CContent
		},
		props: {
			type: {
				type: String,
				validator: value => {
					return ['suspicious-content', 'invalid-share-link', 'form-not-found', 'form-not-available'].includes(value);
				},
				required: true
			},
			notAvailableMessage: {
				type: String,
				default: ''
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {

	.cog-invalid-form {
		// defaults taken from ThemeSettings
		font-family: Arial, Helvetica, sans-serif;
		font-size: 14px;
		line-height: 1.4;

		h1 {
			// taken from CSSBuilder --negative
			color: hsl(2deg, 70%, 47%);

			// defaults taken from ThemeSettings
			font-family: 'Open Sans Condensed', Helvetica, sans-serif;
			font-size: 1.5em;
		}
	}

	&.cog-public-form .cog-form--default-style {
		background: rgb(204, 204, 204, 100%);

		.cog-form__container {
			max-width: 800px;
			background: white;
			box-shadow: 0 0 10px hsla(0deg, 0%, 0%, 10%), 1px 1px 2px hsla(0deg, 0%, 0%, 10%);
			margin: 40px auto 0;
			padding: 30px;

			h1 {
				margin-top: 0;
			}
		}
	}
}

</style>